export const validateEmail = (email: string) => {
	const atIndex = email.indexOf('@')
	const dotIndex = email.lastIndexOf('.')

	if (atIndex === -1 || dotIndex === -1) return false
	if (atIndex > dotIndex) return false
	return true
}
